import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  jobType: "",
  sortBy: "",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    search: (state, action) => {
      state.searchTerm = action.payload;
    },
    type: (state, action) => {
      state.jobType = action.payload;
    },
    sort: (state, action) => {
      state.sortBy = action.payload;
    },
  },
});

export const { search, type, sort } = filterSlice.actions;
export default filterSlice.reducer;
